import { forwardRef, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ERP_LOCATION_NAME_TO_LOCATION_ID_MAP,
  ERP_OUTSTANDING_BILLS,
  ERP_PATIENT_PAYMENT_OBJ,
  ERP_IN_PATIENT_BILLING_LOC_NAME,
  ERP_OUT_PATIENT_BILLING_LOC_NAME,
  ERP_PAYMENT_MODE,
  HEADER_Height,
  MONTH_SHORT_NAME,
  ERP_LABEl_CLEAR_BILL_PAYMENT_ADJUSTMENTS,
  ERP_LABEL_SUBMIT,
  ERP_LABEL_CANCEL,
  ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR,
  HMS_ERP_BILL_CLEAR_ADVANCE_TYPE,
  PATIENT_VISIT_TYPE,
  COMPONENT_WISE_AG_GRID_PAGINATION,
  COMPONENT_WISE_AG_GRID_PAGINATION_SIZE,
  COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT,
  HMS_INVOICE_TYPE_NAME,
  HMS_REPORT_TEMPLATE_TYPE,
  PAGE_MODE,
  MASTER_LOCATION_DATA_LOCATION_KEY,
  INVOICE_REPORT_TYPE,
  INVOICE_DETAILS_LABEL
} from "../../core/constants/erpConstants";
import erpActions, {
  getOutstandingBills,
  savePatientPayment,
  settleUnclearedInvoices,
  successDispatch,
  getInvPDFObject,
} from "./ERPActions/erpActions";
import { generateBillHtml } from "../printConvertion/DocumentConvert";
import { useOrganization } from "../../configurations/OrganizationContext";
import { AgGridReact } from "ag-grid-react";
import { Button } from "@mui/material";
import { helperServices } from "../../shared/helper";
import HeaderFooterComponent from "../printConvertion/HeaderAndFooter";
export default function ERPOutStandingBills(props) {
  console.log("erpoutstandingbill.js page ", props);
  const org = useOrganization();
  const [columnDefs, setColumnDefs] = useState();
  const [rowData, setRowData] = useState([]);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [originalAdvAmount, setOriginalAdvAmountt] = useState(0.0);
  const [advanceAmount, setAdvanceAmount] = useState();
  const [finalAdvanceAmt, setFinalAdvanceAmt] = useState(props.advAmt);
  const [authorizationcode, setAuthorizationcode] = useState(
    props.Authorizationcode
  );
  const [printdata, setPrintData] = useState("");
  const [triggerAction, setTriggerAction] = useState("");
  const [outstandingBillCLearType, setOutstandingBillCLearType] = useState(
    props.billClearType
  );
  const [balanceAmount, setBalanceAmount] = useState();
  const [paymentType, setPaymentType] = useState();
  const [selectedBank, setSelectedBank] = useState();
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  // const [search, setSearch] = useState(props.searchQuery);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisable, setIsDisable] = useState(false);

  // const [pagination, setPagination] = useState({
  //     page: 0,
  //     size: COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPOutstandingBills,
  //   });
  const extractFilters = (tagList) => {
    const textTag = tagList?.find((t) => t?.type === "text");
    const dateTag = tagList?.find((t) => t?.type === "date");

    return {
      search: textTag ? textTag.value : "",
      dateFrom: dateTag ? dateTag.from : "",
      dateTo: dateTag ? dateTag.to : "",
    };
  };

  const [search, setSearch] = useState(
    extractFilters(props?.searchtags)?.search || ""
  );

  // const computeInitialFinalAdvanceAmt = () => {
  //   // if ERPPayment sends a number, use it
  //   if (props && props.advAmt !== undefined && props.advAmt !== null) {
  //     return Number(props.advAmt) || 0;
  //   }
  //   // fallback (no advance available)
  //   return 0;
  // };

  // const [finalAdvanceAmt, setFinalAdvanceAmt] = useState(
  //   computeInitialFinalAdvanceAmt()
  // );

  const dispatch = useDispatch();
  const patientInfo = useSelector(
    (state) => state.patientDetailsState.patientBasic
  );
  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails
  );

  const loggerUserName = helperServices.getLoggedUserID();

  // Add defaultColDef configuration
  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      // flex: 1,
      filter: true,
      resizable: true,
      floatingFilter: true,
    };
  }, []);

  const outstandingBalanceInvoicesColumnDefs = useMemo(() => {
    let cols = [
      // {
      //   headerCheckboxSelection: true,
      //   checkboxSelection: true,
      //   headerName: '',
      //   field: 'checkbox',
      //   flex: .4,
      //    tooltipField: "Checkbox",
      // },
      {
        headerName: "Main",
        field: "patientId",
        colId: "patientId",
        tooltipField: "Patient Id",
        flex: 0.5,
        ...defaultColDef,
      },
      {
        headerName: "IP/OP No",
        field: "ipopnumber",
        flex: 0.4,
        valueGetter: (params) => {
          return params.data?.rowInvoiceData?.patientERPObj?.ipopnumber;
        },
        cellRenderer: (params) => {
          if (!params.value) return "";

          const isClickable = typeof params?.context?.onRowClick === "function";

          return isClickable
            ? `<span class="visit-link">${params.value}</span>`
            : `<span class="visit-link-disabled">${params.value}</span>`;
        },
        onCellClicked: (params) => {
          if (params.event.target.classList.contains("visit-link")) {
            if (typeof props.onRowClick === "function") {
              props.onRowClick({
                patientId: params.data?.rowInvoiceData?.patientERPObj?.id,
                visitId: params.data?.rowInvoiceData?.patientERPObj?.visitId,
              });
            }
          }
        },
        tooltipField: "IP/OP No",
        ...defaultColDef,
      },

      {
        headerName: "Patient Name",
        field: "patientName",
        colId: "patientName",
        tooltipField: "Patient Name",
        flex: 0.5,
        ...defaultColDef,
      },
      {
        headerName: "Invoice No.",
        field: "invoiceNo",
        colId: "invoiceNo",
        tooltipField: "Invoice No",
        flex: 0.5,
        ...defaultColDef,
      },
      {
        headerName: "Invoice Date",
        field: "invoiceDate",
        colId: "invoiceDate",
        tooltipField: "Invoice Amount",
        flex: 0.5,
        ...defaultColDef,
      },
      {
        headerName: "Invoice Type",
        field: "invoiceType",
        colId: "invoiceType",
        tooltipField: "Invoice Type",
        flex: 0.5,
        ...defaultColDef,
      },
      {
        headerName: "Cash/Credit Invoice Type",
        field: "cashCreditInvoiceType",
        colId: "cashCreditInvoiceType",
        tooltipField: "Cash/Credit Invoice Type",
        flex: 0.5,
        ...defaultColDef,
      },
      // {
      //     headerName: 'Bill Amount',
      //     field: 'billTotalAmount',
      //     colId: 'billTotalAmount',
      //     tooltipField: "Bill Amount",
      // },
      {
        headerName: "Outstanding Balance",
        field: "outstandingBalance",
        colId: "outstandingBalance",
        tooltipField: "Balance Amount",
        cellStyle: { textAlign: "right" },
        flex: 0.5,
        ...defaultColDef,
      },
      {
        headerName: "Payment",
        field: "paymentAmount",
        editable: true,
        cellStyle: { textAlign: "right", fontWeight: "bold" },
        editable: true,
        flex: 0.5,
        valueSetter: (params) => {
          const newValue = Number(params.newValue || 0);
          const currentRow = params.data;
          const api = params.api;

          if (newValue > currentRow.outstandingBalance) {
            //alert(`Payment cannot exceed the outstanding balance of ₹${currentRow.outstandingBalance}`);
            return false;
          }

          let otherTotal = 0;
          api.forEachNode((node) => {
            if (node.data.invoiceNo !== currentRow.invoiceNo) {
              otherTotal += Number(node.data.paymentAmount || 0);
            }
          });

          const proposedTotal = otherTotal + newValue;

          if (proposedTotal > finalAdvanceAmt) {
            // alert(`Total payment exceeds available advance of ₹${finalAdvanceAmt}`);
            return false;
          }

          currentRow.paymentAmount = newValue;
          return true;
        },
      },
      {
        headerName: "Balance Amount",
        field: "balanceAmount",
        colId: "balanceAmount",
        valueGetter: "data.outstandingBalance - data.paymentAmount",
        valueFormatter: (params) => {
          // if (typeof params.value === 'number') {
          return params.value.toFixed(2);
          // }
          // return params.value; // Return original value if not a number
        },
        tooltipField: "Payment Amount",
        cellStyle: { textAlign: "right" },
        flex: 0.5,
        ...defaultColDef,
      },
    ];

    if (
      HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_All_PATIENT_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR ===
      outstandingBillCLearType
    ) {
      cols.push({
        headerName: "Action",
        field: "action",
        colId: "action",
        cellRenderer: "ActionRenderer",
        // cellStyle: { textAlign: 'right', },
        // ...defaultColDef,
        tooltipField: "Action",
      });
    }
    // setColumnDefs(cols);
    return cols;
  }, [outstandingBillCLearType]);

  const rowStyle = {
    background: "white",
    display: "flex",
    justifyContent: "center",
    BorderBottom: "1px solid #D0D0D0",
  };
  const containerStyle = useMemo(
    () => ({
      width: "100%",
      height: COMPONENT_WISE_AG_GRID_CONTAINER_HEIGHT.ERPOutstandingBills,
    }),
    []
  );
  const gridStyle = useMemo(
    () => ({ alignItems: "start", height: "100%", width: "100%" }),
    []
  );

  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);

  // First, create an ActionRenderer component at the top of your file, after the imports
  const ActionRenderer = (cellProps) => {
    console.log("ActionRenderer: ", cellProps);

    let paymentAmount = 0;
    if (cellProps.data.paymentAmt) {
      paymentAmount = cellProps.data.paymentAmt.replace("₹ ", "");
    }
    console.log("ActionRenderer paymentAmount : ", paymentAmount);

    //paynow towards the invoice
    const handleInvoicePayment = (cellProps) => {
      console.log("handleInvoicePayment method is called: ", cellProps);
      try {
        // Prefer a numeric field if present, else parse from formatted string
        // let payableAmount = 0;
        // if (typeof cellProps.data.paymentAmt === 'number') {
        //     payableAmount = cellProps.data.paymentAmt;
        // } else if (typeof cellProps.data.paymentAmt === 'string') {
        //     const parsed = Number(String(cellProps.data.paymentAmt).replace(/[^0-9.\-]/g, ''));
        //     payableAmount = isNaN(parsed) ? 0 : parsed;
        // }
        // Invoke parent handler to open ERPPayment in outstanding-bill mode
        // if (onClearInvoiceStart) {
        props.onClearInvoiceStart({
          amount: paymentAmount,
          rowData: cellProps.data,
        });
        // }
      } catch (e) {
        console.error("Error while preparing invoice payment details:", e);
      }
    };

    const handlePrintInvoice = (cellProps, actionType) => {
      setIsDisable(true);
      const formatted = prepareOutstandingInvoiceData(cellProps.data);

      const templateReportType = HMS_REPORT_TEMPLATE_TYPE.SINGLE_INVOICE;

      handleInvoiceReport(formatted, templateReportType, actionType);
    };

    const handleInvoiceReport = async (
      rowData,
      templateReportType,
      actionType
    ) => {
      console.log("invoice report print rowData: ", rowData);
      let masterLocDetails = [];
      let ticketId = rowData.isConsolidated ? null : rowData.ticketId;
      let customerId = rowData.isConsolidated ? rowData.customerId : null;
      let visitId = rowData.isConsolidated ? rowData.visitId : null;
      let reportType = rowData.isConsolidated
        ? INVOICE_REPORT_TYPE.CONSOLIDATED
        : null;
      let locationIds = rowData.isConsolidated
        ? helperServices.getFirstLocationIdByKey(
          masterLocDetails,
            MASTER_LOCATION_DATA_LOCATION_KEY.ALL
          )
        : null;

      console.log("getInvPDFObject input parameters: ", ticketId, visitId, customerId, reportType, locationIds);
      const printPDF = await getInvPDFObject(
        ticketId,
        visitId,
        customerId,
        reportType,
        locationIds
      );

      console.log("PRINT PDF: ", printPDF);
      const data = await generateBillHtml(
        printPDF.hmsInvReportDTOList,
        templateReportType,
        org?.orgCode
      );
      console.log("Generated HTML Data: ", data);
      setPrintData(data);
      setTriggerAction(actionType);
      setIsDisable(false);
    };
    

    const prepareOutstandingInvoiceData = (data) => {
      console.log("prepareOutstandingInvoiceData: ", data);
      return {
        ticketId: data.ticketId,
        invoiceId: data.invoiceNo,
        patientId: data.patientId,
        visitId: data.rowInvoiceData?.patientERPObj?.visitId || null,
        isConsolidated: data.rowInvoiceData?.isConsolidated,
        customerId: data.rowInvoiceData?.customerId,
      };
    };


    return (
      // gap: '30px',

      <div
        style={{
          display: "flex",
          justifyContent: "start",
          columnGap: "15px",
          marginLeft: "10px",
        }}
      >
        {props.pageMode === PAGE_MODE.ALL_INVOICELIST && (
          <div
            className="icon-btn text-dark"
            title={isDisable ? "Disabled" : "Print Invoice"}
            onClick={
              !isDisable
                ? () =>
                    handlePrintInvoice(cellProps, "print", cellProps.data.type)
                : undefined
            }
            style={{
              pointerEvents: isDisable ? "none" : "auto",
              opacity: isDisable ? 0.5 : 1,
              cursor: isDisable ? "not-allowed" : "pointer",
            }}
          >
            <i className="material-icons">print</i>
          </div>
        )}
        <div
          title="Approve"
          className={isDisabled ? "buttonDisabled" : ""}
          style={{ color: "#4CAF50", cursor: "pointer" }}
          onClick={() => handleInvoicePayment(cellProps)}
        >
          <i className="material-icons">check</i>
        </div>
      </div>
    );
  };

  const getMasterlocationDetails = async () => {
    let masterLocDetails = [];
    if(!masterLocationDetails){
      masterLocDetails = await erpActions.getAllMasterLocationDetails(dispatch);
    }else{
      masterLocDetails = masterLocationDetails;
    }
    return masterLocDetails;
  }

  const handleSubmit = async () => {
    if (isDisabled) return;
    // setShowOutstandingBill(true);
    setIsDisabled(true);
    try {
      if (
        HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR ===
        outstandingBillCLearType
      ) {
        await updateUnclearedInvoicesSettlement();
      } else {
        let pType = "";
        let pAmount = 0;

        let paymentModeWiseInvoices = {};

        const paymentTypeWithAmount = props.paymentTypeWithAmount || {};

        let invoiceRemaining = (filteredRowData && filteredRowData.length>0)? filteredRowData.map((row) => ({
          ...row,
          remainingNeed: Number(row.paymentAmount) || 0, // THIS REDUCES AFTER EACH MODE
        })) : [];

        for (let key in paymentTypeWithAmount) {
          if (paymentTypeWithAmount[key] > 0) {
            let pType = key;
            let pAmount = paymentTypeWithAmount[key];

            // create bucket
            paymentModeWiseInvoices[pType] = [];

            let currencyInfo = ERP_PATIENT_PAYMENT_OBJ.currencyInfo;

            invoiceRemaining.forEach((inv) => {
              if (pAmount <= 0) return;

              if (inv.remainingNeed <= 0) return; // already cleared by earlier mode

              let payNow = 0;

              if (pAmount >= inv.remainingNeed) {
                // full remaining payment
                payNow = inv.remainingNeed;
                pAmount -= inv.remainingNeed;
                inv.remainingNeed = 0; // mark fully paid
              } else {
                // partial payment
                payNow = pAmount;
                inv.remainingNeed -= pAmount;
                pAmount = 0;
              }

              paymentModeWiseInvoices[pType].push({
                ...inv.rowInvoiceData,
                paidBillAmount: payNow,
                paymentAmount: payNow,
                outstandingBalance:
                  inv.balanceAmount - (inv.paymentAmount - inv.remainingNeed),
                paidAmount: payNow,
                currencyInfo,
                paymentMode: pType,
              });
            });
          }
        }
        for (let pType in paymentModeWiseInvoices) {
          const paymentResp = await savePatientPaymentDetails(
            pType,
            paymentTypeWithAmount[pType],
            paymentModeWiseInvoices[pType]
          );
          console.log("PaymentResp ", paymentResp);
        }
      }
    } finally {
      props.closePaymentPage(false);
      setIsDisabled(false);
    }
  };

  const closePaymentComponent = () => {
    // setShowOutstandingBill(true);
    if (isDisabled) return;
    setIsDisabled(true);
    props.closePaymentPage(false);
    setIsDisabled(false);
  };

  async function savePatientPaymentDetails(pType, pAmount, invList) {
    const paymentObj = { ...ERP_PATIENT_PAYMENT_OBJ };
    console.log("advanceAmount: ", advanceAmount);
    console.log("advanceAmount props : ", props);
    let masterLocDetails = await getMasterlocationDetails();
    paymentObj.bankDepositDescription = `Patient #${patientInfo.id} ${patientInfo.fname} payment`;
    paymentObj.paymentMode = pType;
    paymentObj.paymentAmount = pAmount;
    paymentObj.customerId = patientInfo.erpCustId;
    paymentObj.customerName = patientInfo.fname;
    paymentObj.customerInfo.customerId = patientInfo.erpCustId;
    paymentObj.customerInfo.customerName = patientInfo.fname;
    paymentObj.paymentDate = new Date();
    paymentObj.timestamp = new Date();
    paymentObj.user = loggerUserName;
    // paymentObj.
    let locationId = 0;

    locationId = await helperServices.getLocationIdByvisitType(
      masterLocDetails,
      patientInfo?.visit?.type
    );
    if (
      selectedBank &&
      (ERP_PAYMENT_MODE.Credit_Card == paymentType ||
        ERP_PAYMENT_MODE.UPI == paymentType)
    ) {
      paymentObj.bankId = selectedBank.bankId;
      paymentObj.bankName = selectedBank.bankName;
      paymentObj.checkNo = authorizationcode;
    }
    console.log("sav patient payment : ", locationId, paymentObj);

    if (ERP_PAYMENT_MODE.CASH != paymentType) {
      paymentObj.checkDate = new Date();
    }
    paymentObj.customerTickets = invList;
    paymentObj.customerPayment = invList;
    paymentObj.description = props.description || "";
    console.log("invPaymentDetails: ", invList);

    let paymentResp = "";
    let advAmt = { ...advanceAmount };
    // if (((ERP_PAYMENT_MODE.CASH == paymentType || ERP_PAYMENT_MODE.UPI == paymentType) && advAmt > 0) || (ERP_PAYMENT_MODE.Credit_Card == paymentType)) {
    paymentResp = await savePatientPayment(locationId, paymentObj);
    // }

    if (paymentResp) {
      //serverResposnes("OutStanding bill payment Successfull","success");
      console.log("paymentResp: ", paymentResp);
    } else {
      //serverResposnes("OutStanding bill payment ","error");
    }
  }

  async function updateUnclearedInvoicesSettlement() {
    const paymentObj = ERP_PATIENT_PAYMENT_OBJ;
    paymentObj.paymentAmount = 0.0;
    let invPaymentDetails = [];
    console.log("settleUnclearedInvoices: ", filteredRowData);

    if (filteredRowData && filteredRowData.length > 0) {
      let currencyInfo = paymentObj.currencyInfo;
      filteredRowData.forEach((row) => {
        if (row.paymentAmount > 0) {
          console.log("each Row Data with payment amt > 0: ", row);
          // row['paidBillAmount'] = row.paymentAmount;
          // return row;
          invPaymentDetails.push({
            // 'ticketId': row.ticketId,
            ...row.rowInvoiceData,
            paidBillAmount: row.paymentAmount,
            currencyInfo: currencyInfo,
            // 'paymentAmount': row.paymentAmount,
            // 'outstandingBalance': row.balanceAmount,
            // 'paidAmount': row.paymentAmount,
          });
          // return {'ticketId': row.ticketId, 'paidBillAmount': row.paymentAmount };
        }
        console.log("invPaymentDetails : ", invPaymentDetails);
      });
    }

    paymentObj.customerTickets = invPaymentDetails;
    paymentObj.customerPayment = invPaymentDetails;
    paymentObj.user = loggerUserName;
    const invSettlementResp = await settleUnclearedInvoices(
      patientInfo.id,
      patientInfo.visit.id,
      paymentObj
    );
  }

  const fetchAllOutstandingBills = async (
    page,
    size,
    location,
    advAmt,
    custId
  ) => {
    let showConsolidatedInvoices = false;
    let iskpcash = null;
    if (!custId) {
      if (props.patientId && props.visitId) {
        custId = patientInfo.erpCustId;
      } else {
        showConsolidatedInvoices = true;
        iskpcash = null;
      }
    }
    const allOutstandingBills = await getOutstandingBills(
      page,
      size,
      location,
      custId,
      showConsolidatedInvoices,
      iskpcash
    );

    if (allOutstandingBills) {
      console.log("allOutstandingBills: ", allOutstandingBills);

      if (Array.isArray(allOutstandingBills.customerBills)) {
        dispatch(
          successDispatch(
            ERP_OUTSTANDING_BILLS,
            allOutstandingBills.customerBills
          )
        );
        updateOutstandingBills(allOutstandingBills.customerBills, advAmt);
        return;
      }
    }

    updateOutstandingBills([], advAmt);
  };

  const updateOutstandingBills = (outstandingBills, advAmt) => {
    console.log("updateOutstandingBills : ", outstandingBills);
    let rowList = [];
    if (outstandingBills) {
      let advAmount = advAmt;
      outstandingBills.forEach((outstandingBill) => {
        console.log("outstandingBill: ", outstandingBill);
        const invDate = new Date(outstandingBill.invoiceDate);
        let paymentAmt = 0;
        let outstandingBal = outstandingBill.outstandingBalance;
        if (advAmount > 0) {
          if (outstandingBal >= advAmount) {
            paymentAmt = advAmount;
            advAmount = 0;
          } else if (outstandingBal < advAmount) {
            paymentAmt = outstandingBal;
            advAmount = advAmount - outstandingBal;
          }
        }
        let row = {
          patientId: outstandingBill?.patientERPObj?.id,
          patientName: outstandingBill.patientERPObj
            ? helperServices.getFullName(
                outstandingBill?.patientERPObj?.fname,
                outstandingBill?.patientERPObj?.mname,
                outstandingBill?.patientERPObj?.lname
              )
            : outstandingBill?.customerName,
          invoiceNo: outstandingBill.invoiceNo,
          invoiceType: outstandingBill.isConsolidated
            ? HMS_INVOICE_TYPE_NAME.CONSOLIDATED_INVOICE
            : HMS_INVOICE_TYPE_NAME.INDIVIDUAL_INVOICE,
          cashCreditInvoiceType: outstandingBill.isKpCash? INVOICE_DETAILS_LABEL.KPCASH : INVOICE_DETAILS_LABEL.KPCREDIT,
          outstandingBalance: outstandingBill.outstandingBalance,
          paidAmount: outstandingBill.paidAmount,
          paymentAmount: paymentAmt,
          balanceAmount: outstandingBill.outstandingBalance,
          ticketId: outstandingBill.ticketId,
          invoiceDate: `${invDate.getDate()}-${
            MONTH_SHORT_NAME[invDate.getMonth()]
          }-${invDate.getFullYear()}`,
          billTotalAmount: outstandingBill.billTotalAmount,
          rowInvoiceData: outstandingBill,
        };
        rowList.push(row);
      });
      if (props && props.updateAdvAmt) {
        props.updateAdvAmt(advAmount);
      }
      setAdvanceAmount(advAmount);
    }
    console.log("outstanding bills rows : ", rowList);

    setRowData(rowList);
    setFilteredRowData(rowList);
  };

  // const handleFilteredRows = (searchParam) => {

  // }, [search]

  const handleCellEdit = (params) => {
    const updatedRow = params.data;
    const column = params.colDef.field;
    const newValue = params.newValue;
    const oldValue = params.oldValue;

    if (newValue !== oldValue) {
      console.log("Edited field:", column);
      console.log("Old value:", oldValue);
      console.log("New value:", newValue);
      console.log("Updated row:", updatedRow);

      updatePaymentAmount(updatedRow, column);
    }
  };

  const handleCellDoubleClick = (params) => {
    const column = params.colDef.field;

    if (column === "paymentAmount") {
      const row = { ...params.data };
      const rowIndex = filteredRowData.findIndex(
        (r) => r.invoiceNo === row.invoiceNo
      );

      if (row.paymentAmount == 0 && advanceAmount > 0) {
        const outstanding = Number(row.outstandingBalance || 0);
        const paymentToApply = Math.min(outstanding, advanceAmount);

        if (paymentToApply > 0) {
          row.paymentAmount = paymentToApply;

          const updatedRows = [...filteredRowData];
          updatedRows[rowIndex] = row;

          setRowData(updatedRows);

          const newAdvanceAmount = advanceAmount - paymentToApply;
          setAdvanceAmount(newAdvanceAmount);
          props.updateAdvAmt(newAdvanceAmount);
        }
      }
    }
  };

  const updatePaymentAmount = (editRow, column) => {
    if (column === "paymentAmount") {
      console.log("finalAdvanceAmt:", finalAdvanceAmt);
      const updatedRows = [...filteredRowData];
      const rowIndex = updatedRows.findIndex(
        (row) => row.invoiceNo === editRow.invoiceNo
      );
      if (rowIndex !== -1) {
        updatedRows[rowIndex] = editRow;
      }
      const totalPaid = updatedRows.reduce(
        (sum, row) => sum + Number(row.paymentAmount || 0),
        0
      );
      const newAdvanceAmount = finalAdvanceAmt - totalPaid;
      console.log("New advanceAmount:", newAdvanceAmount);
      setAdvanceAmount(newAdvanceAmount);
      props.updateAdvAmt(newAdvanceAmount);
    }
  };

  const handleClearAllPayments = () => {
    if (isDisabled) return;
    setIsDisabled(true);
    const updatedRows = filteredRowData && filteredRowData.length > 0 ? filteredRowData.map((row) => ({
      ...row,
      paymentAmount: 0,
    })) : [];
    setRowData(updatedRows);
    setAdvanceAmount(finalAdvanceAmt);
    props.updateAdvAmt(finalAdvanceAmt);

    setIsDisabled(false);
    // setServerRes({
    //     success: "All payments cleared.",
    //     error: ""
    // });

    // setTimeout(() => {
    //     setServerRes({ success: "", error: "" });
    // }, 2000);
  };

  const handleFilteredData = () => {
    if (rowData) {
      const allRows = [...rowData];
      console.log("search: && rowData: ", search, allRows);
      if (search) {
        // const filteredRowData = rowData.filter((row)=>{
        //     // return row.invoiceNo.toLowerCase().includes(search.toLowerCase());
        //     return fuzzyFilter(row, search);
        // });
        let filterRows = [];
        for (let row of rowData) {
          if (helperServices.fuzzyFilter(row, search)) {
            filterRows.push(row);
          }
        }
        console.log("filtered rows : ", filterRows);

        setFilteredRowData(filterRows);
      } else {
        setFilteredRowData(rowData);
      }
    }
  };

  const updatingFilteredRow = useMemo(
    () => handleFilteredData(rowData, search),
    [rowData, search]
  );

  useEffect(async () => {
    console.log("props: ", props);
    console.log(
      "props to get rowdata selectedLocation: ",
      props.selectedLocation
    );
    let masterLocDetails = await getMasterlocationDetails();
    const selected = props.selectedLocation?.[0];
    console.log("SELECTED: ", selected);
    let locationid = masterLocDetails
      ? helperServices.getFirstLocationIdByKey(
        masterLocDetails,
          MASTER_LOCATION_DATA_LOCATION_KEY.ALL
        )
      : 0;
    if (selected?.locationKey?.toLowerCase() === "all") {
      const allLocationIds = locationid;
      // .filter((id) => id !== ERP_LOCATION_NAME_TO_LOCATION_ID_MAP["PHARMACY"]);
      locationid = allLocationIds;
    } else if (selected) {
      locationid =
        selected?.locationDetails?.erpLocationDetails?.[0].locationid || 0;
    }
    const erpcustid = selected?.clientERPCustId || null;
    fetchAllOutstandingBills(
      0,
      200,
      locationid,
      finalAdvanceAmt ?? 0,
      erpcustid
    );
  }, [props.selectedLocation]);

  useEffect(async () => {
    console.log("props to get rowdata: ", props);
    let masterLocDetails = await getMasterlocationDetails();

    setColumnDefs(outstandingBalanceInvoicesColumnDefs);
    if (props.rowData) {
      setRowData(props.rowData);
    }
    if (props.advAmt) {
      console.log("Advance amount : ", props.advAmt);
      setAdvanceAmount(props.advAmt);
    }
    if (props.pymtType) {
      setPaymentType(props.pymtType);
    }
    if (props.bankDetails) {
      setSelectedBank(props.bankDetails);
    }

    // let location = props.location ? props.location : 0;
    const selected =
      props.selectedLocation?.[0]?.locationDetails?.erpLocationDetails?.[0];

    let locationid = 0;
    if (selected?.name === "All") {
      // try {
        locationid = masterLocDetails?.filter((loc) => loc.locationKey).map((loc) => loc.locationId);
      // } catch (error) {
      //           locationid = masterLocationDetails
      //     ?.filter((loc) => loc.locationKey)
      //     .map((loc) => loc.locationId);
      // }
    } else {
      locationid = selected?.locationid || 0;
    }

    const erpcustid = selected?.erpCustId || null;
    // if (patientInfo && patientInfo.erpCustId) {
    // if (props.patientId && props.visitId) {
    // fetchAllOutstandingBills(location, props.advAmt ?? 0);
    // fetchAllOutstandingBills(
    //   0,
    //   15,
    //   locationid,
    //   finalAdvanceAmt ?? 0,
    //   erpcustid
    // );

    // }
  }, [patientInfo && patientInfo.erpCustId]);

  useEffect(() => {
    console.log("outstanding biills rowdatas: ", filteredRowData);
    console.log("outstanding biills columnDefs: ", columnDefs);
    console.log("Search Query : ", search, props?.searchtags);
  }, [filteredRowData]);

  useEffect(() => {
    console.log("Search Query : ", search, props?.searchtags);
    setSearch(extractFilters(props?.searchtags).search);
  }, [props?.searchtags]);

  useEffect(() => {
    handleFilteredData();
  }, [rowData, search]);

  return (
    <div className="h-100">
      <div className="ms-1" style={containerStyle}>
        <div
          className="ag-theme-balham ag-style ag-header-left pt-3 pb-2 w-100 h-100"
          style={gridStyle}
        >
          <AgGridReact
            autoSizeStrategy={autoSizeStrategy}
            rowData={filteredRowData}
            overlayNoRowsTemplate="No records found"
            rowStyle={rowStyle}
            pagination={COMPONENT_WISE_AG_GRID_PAGINATION.ERPOutstandingBills}
            paginationPageSize={
              COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPOutstandingBills
            }
            // defaultColDef={defaultColDef}
            columnDefs={columnDefs}
            headerHeight={HEADER_Height}
            onCellValueChanged={handleCellEdit}
            onCellDoubleClicked={handleCellDoubleClick}
            frameworkComponents={{
              ActionRenderer: ActionRenderer,
            }}
            onPaginationChanged={(params) => {
              const currentPage = params.api.paginationGetCurrentPage();
              console.log("currentPage: ", currentPage);

              // fetchData(currentPage, pagination.size);
              // fetchAllOutstandingBills(currentPage, COMPONENT_WISE_AG_GRID_PAGINATION_SIZE.ERPOutstandingBills, 0, props.advAmt ?? 0);
            }}
            context={{ onRowClick: props.onRowClick }}
          />
        </div>
      </div>
      {HMS_ERP_BILL_CLEAR_ADVANCE_TYPE.ERP_All_PATIENT_OUTSTANDING_BILLS_TYPE_DIRECT_CLEAR !==
        outstandingBillCLearType && (
        <div className="paymentButtonMainDiv removeMargin me-2">
          <div className="justify-content-around">
            <button
              className="bg-primary text-white border rounded p-2 me-3"
              disabled={isDisabled}
              onClick={() => handleClearAllPayments()}
            >
              {ERP_LABEl_CLEAR_BILL_PAYMENT_ADJUSTMENTS}
            </button>
            <button
              className="bg-primary text-white border rounded p-2 me-3"
              disabled={isDisabled}
              onClick={() => handleSubmit()}
            >
              {ERP_LABEL_SUBMIT}
            </button>
            <button
              className="bg-primary text-white border rounded p-2"
              disabled={isDisabled}
              onClick={() => closePaymentComponent()}
            >
              {ERP_LABEL_CANCEL}
            </button>
            {/* <Button
                    variant="contained"
                    color="primary"
                    // sx={{ textTransform: "capitalize" }}
                    // className="btn btn-submit btn-primary btn-style bottomright"
                    onClick={() => handleSubmit()}
                  >
                  Submit
                  </Button>
                  <Button
                  variant="contained"
                  color="primary"
                  // sx={{ textTransform: "capitalize" }}
                  // className="btn btn-submit btn-primary btn-style bottomright"
                  onClick={() => closePaymentComponent()}
                  >
                  Cancel
                  </Button> */}
          </div>
        </div>
      )}
      {printdata && triggerAction && (
        <HeaderFooterComponent
          title="Invoice"
          data={printdata}
          triggerAction={triggerAction}
          onComplete={() => {
            setPrintData(""); // clear data
            setTriggerAction(""); // clear action
            console.log("Print action completed and state cleared.");
          }}
        />
      )}
    </div>
  );
}
